<script setup>
import { useOnlineStatus } from '../composables/useOnlineStatus'
import { t } from '../services/i18nService'

const { isOnline, wasOffline } = useOnlineStatus()
</script>

<template>
  <!-- Баннер отсутствия сети -->
  <Transition name="offline-banner">
    <div v-if="!isOnline" class="offline-banner offline-banner--error">
      <span class="material-symbols-outlined offline-banner__icon">wifi_off</span>
      <div class="offline-banner__content">
        <span class="offline-banner__title">{{ t('network.offline') }}</span>
        <span class="offline-banner__message">{{ t('network.offlineMessage') }}</span>
      </div>
    </div>
  </Transition>

  <!-- Баннер восстановления соединения -->
  <Transition name="offline-banner">
    <div v-if="isOnline && wasOffline" class="offline-banner offline-banner--success">
      <span class="material-symbols-outlined offline-banner__icon">wifi</span>
      <div class="offline-banner__content">
        <span class="offline-banner__title">{{ t('network.online') }}</span>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.offline-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: calc(0.75rem + env(safe-area-inset-top, 0px)) 1rem 0.75rem;
  font-size: var(--text-sm);
  font-weight: 500;
  box-shadow: var(--shadow-md);
}

.offline-banner--error {
  background: linear-gradient(135deg, var(--danger) 0%, var(--danger-hover) 100%);
  color: var(--text-inverse);
}

.offline-banner--success {
  background: linear-gradient(135deg, var(--success) 0%, var(--success-hover) 100%);
  color: var(--text-inverse);
}

.offline-banner__icon {
  font-size: var(--text-xl);
  flex-shrink: 0;
}

.offline-banner__content {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.offline-banner__title {
  font-weight: 600;
}

.offline-banner__message {
  font-size: var(--text-xs);
  opacity: 0.9;
}

/* Анимация появления/исчезновения */
.offline-banner-enter-active,
.offline-banner-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.offline-banner-enter-from,
.offline-banner-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
